import moment from 'moment'
import saver from 'file-saver'
// import {dataToExcel} from './xls.js'

const WEEK = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']

function fix2digit(number) {
  number = parseInt(number)
  return number < 10 ? ('0' + number) : number
}

export default {
  uuid() {
    var s = []
    var hexDigits = '0123456789abcdef'
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4'  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-'
    var uuid = s.join('')
    return uuid
  },
  // saveDataToExcel (data, fileName, done) {
  //   let Worker = require('worker-loader!./worker')
  //   let w = new Worker()
  //   w.postMessage({data: data, fileName: fileName})
  //   w.onmessage = function (e) {
  //     saver.saveAs(e.data.data, `${fileName}.xlsx`)
  //     if (done !== undefined) {
  //       done()
  //     }
  //   }
  //   // saver.saveAs(dataToExcel(data), `${fileName}.xlsx`)
  //   // if (done !== undefined) {
  //   //   done()
  //   // }
  // },
  saveDataToExcel(data, fileName, fag) {
    let Worker = require('worker-loader!./worker')
    let w = new Worker()
    w.postMessage({ data: data, fileName: fileName, fag })
    w.onmessage = function (e) {
      saver.saveAs(e.data.data, `${fileName}.xlsx`)
    }
  },
  formatDate(number) {
    var date = number ? new Date(number) : new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    if (month < 10) {
      month = '0' + month
    }
    let day = date.getDate()
    if (day < 10) {
      day = '0' + day
    }
    return year + '-' + month + '-' + day
  },
  formatTime(number) {
    let day = number ? new Date(number) : new Date()
    let dayWrapper = moment(day).format('YYYY-MM-DD HH:mm:ss')
    return dayWrapper
  },
  formatWeek(ms) {
    return WEEK[new Date(ms).getDay()]
  },
  formatYearMonth(number) {
    var date = new Date(number)
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    if (month < 10) {
      month = '0' + month
    }
    let day = date.getDate()
    if (day < 10) {
      day = '0' + day
    }
    return year + '-' + month
  },
  // formatTime (number) {
  //   var date = new Date(number)
  //   let year = date.getFullYear()
  //   let month = date.getMonth() + 1
  //   if (month < 10) {
  //     month = '0' + month
  //   }
  //   let day = date.getDate()
  //   if (day < 10) {
  //     day = '0' + day
  //   }
  //   let hour = date.getHours()
  //   if (hour < 10) {
  //     hour = '0' + hour
  //   }
  //   let minutes = date.getMinutes()
  //   if (minutes < 10) {
  //     minutes = '0' + minutes
  //   }
  //   let seconds = date.getSeconds()
  //   if (seconds < 10) {
  //     seconds = '0' + seconds
  //   }
  //   return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds
  // },
  setTempParam(param) {
    window.temporaryParam = param
  },
  getTempParam() {
    return window.temporaryParam
  },
  clearTempParam() {
    window.temporaryParam = undefined
  },
  formatPrice(number) {
    if (number || number == 0) {
      return parseFloat(number / 100).toFixed(2)
    } else {
      return '-'
    }
  },
  formatShortTime(time) {
    return `${fix2digit(time / 100)}:${fix2digit(time % 100)}`
  },
  formatShortTimeWithDay(ms, time) {
    let d1 = moment(new Date(2000, 1, 1, time / 100, time % 100, 0, 0))
    let d2 = d1.clone().subtract(ms, 'milliseconds')
    let d3 = d2.clone()
    d3.set('hour', time / 100)
    d3.set('minute', time % 100)
    let days = d1.diff(d3, 'days')
    if (days === 0) {
      return `当天, ${fix2digit(d2.hours())}:${fix2digit(d2.minutes())}`
    } else {
      return `提前${days}天,  ${fix2digit(d2.hours())}:${fix2digit(d2.minutes())}`
    }
  },
  formatShortTimeWithDaySplit(ms, time) {
    let d1 = moment(new Date(2000, 1, 1, time / 100, time % 100, 0, 0))
    let d2 = d1.clone().subtract(ms, 'milliseconds')
    let d3 = d2.clone()
    d3.set('hour', time / 100)
    d3.set('minute', time % 100)
    let days = d1.diff(d3, 'days')
    return { day: days.toString(), time: `${fix2digit(d2.hours())}:${fix2digit(d2.minutes())}` }
  },
  // 12:00 - > 1200
  timeToInt(time) {
    return parseInt(time.replace(/:/, ''))
  },
  // 1200 -> 12:00
  intToTime(int) {
    if (typeof int !== 'number') {
      return ''
    }
    let string = int.toString()
    let length = string.length
    let fullString = '0000'.substring(length) + string
    return fullString.substr(0, 2) + ':' + fullString.substr(2, 2)
  },
  timeBetweenEndTimeInMs(days, time, endTime) {
    let d1 = moment(new Date(2000, 1, 1, endTime / 100, endTime % 100, 0, 0))
    let d2 = moment(new Date(2000, 1, 1, time / 100, time % 100, 0, 0))
    d2.subtract(parseInt(days), 'day')
    return d1.diff(d2, 'milliseconds')
  },
  initLowerCase(str) {
    if (typeof str !== 'string' || str.length === 0) {
      return ''
    }
    let arr = str.split('')
    arr[0] = arr[0].toLowerCase()
    return arr.join('')
  },
  isInteger(obj) {
    return typeof obj === 'number' && obj % 1 === 0
  },
  addTitleAttrForList() {
  },
  dealwithAddress(address, companyId) {
    // 萧山 病区不显示
    let addressList = address.split('|')
    if (companyId === 8 || companyId === 9) {
      addressList.splice(0, 1)
      addressList.splice(2, 1)
    }
    return addressList.join(' ')
  },
  timeRange(beginTime, endTime) {
    var b = new Date();
    var e = new Date();
    var n = new Date();
    var strb = beginTime.split(":");
    var stre = endTime.split(":");
    b.setHours(strb[0]);
    b.setMinutes(strb[1]);
    e.setHours(stre[0]);
    e.setMinutes(stre[1]);

    if (n.getTime() - b.getTime() > 0 && n.getTime() - e.getTime() < 0) {
      return true;

    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js